import { render, staticRenderFns } from "./ClassCreateModal.vue?vue&type=template&id=19d40181&scoped=true&"
import script from "./ClassCreateModal.vue?vue&type=script&lang=js&"
export * from "./ClassCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassCreateModal.vue?vue&type=style&index=0&id=19d40181&prod&scoped=true&lang=css&"
import style1 from "./ClassCreateModal.vue?vue&type=style&index=1&id=19d40181&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d40181",
  null
  
)

export default component.exports